// บรอดแคสต์ home / popup / report / library strings (key group broadcast.screens), merged at boot like
// locales/broadcast.js. Thai is verbatim from the Proship Messenger mockup (docs/mockups/messenger-in-proship/app.js).
// No literal braces in values: vue-i18n reads {x} as a parameter. Texts that carry the customer placeholder
// (the prefilled messages, the ใส่ chip) live in components/derived/broadcast/copy.js.
const th = {
  home: {
    title: "บรอดแคสต์",
    empty_line: "ส่งข้อความหาลูกค้าที่ทักมาใน 24 ชม. ได้หลายคนพร้อมกัน",
    create: "สร้างบรอดแคสต์",
    saved: "ข้อความที่บันทึกไว้",
    guide: "ดูคู่มือพร้อมรูป",
    customers: "ดูลูกค้าที่เคยทักมา",
    gate_line: "เชื่อมต่อเพจก่อน ปุ่มด้านบนถึงจะกดได้ ใช้เวลาไม่ถึงนาที",
    connect: "เชื่อมต่อเพจ Facebook",
    prefix_24: "24 ชม. · ",
    prefix_all: "ทุกคนที่เคยทัก · ",
    from_pages: "จาก {n} เพจ",
    delivered: "ถึงแล้ว {n}",
    read: "อ่านแล้ว {n}",
    failed: "ส่งไม่ได้ {n}",
  },
  status: {
    sending: "กำลังส่ง",
    paused: "หยุดชั่วคราว",
    autopause: "หยุดอัตโนมัติ",
    cancelled: "ยกเลิกแล้ว",
    done: "ส่งครบแล้ว",
  },
  scope: {
    title: "ส่งถึงใคร?",
    why: "เลือกว่าจะส่งถึงใคร",
    day: "ลูกค้าที่ทักมาใน 24 ชม.",
    inbox: "ลูกค้าทุกคนที่เคยทักมา",
  },
  group: {
    title: "กลุ่มไหน?",
    ok: "ตกลง",
    tracked: "ส่งเลขพัสดุจากโปรชิปแล้ว",
    ordered: "สั่งแล้ว",
    ordered_sub: "มีออเดอร์ในโปรชิปแล้ว",
    interested: "สนใจแต่ยังไม่สั่ง",
    interested_sub: "ทักมามากกว่า 1 ข้อความ ยังไม่มีออเดอร์",
    one_message: "ทักมาข้อความเดียว",
    one_message_sub: "ทักมาข้อความเดียว ยังไม่มีออเดอร์",
    all: "ทุกคน",
  },
  next: "ถัดไป",
  compose: {
    title: "จะส่งข้อความว่าอะไร?",
    why: "พิมพ์ข้อความได้เลย ใส่รูปก็ได้",
    put: "ใส่",
    placeholder: "พิมพ์ข้อความ",
    add_image: "ใส่รูป",
    remove_image: "เอารูปออก",
    preview: "ลูกค้าเห็นแบบนี้",
    type_above: "พิมพ์ข้อความด้านบน…",
    too_long: "ความยาวข้อความถึงขีดจำกัดแล้ว",
  },
  itype: {
    title: "ส่งข้อความแบบไหน?",
    after: "หลังการขาย",
    account: "อัปเดตแอคเคาน์",
    event: "อัปเดตอีเวนต์",
    own: "เขียนเอง",
    own_warn: "ข้อความเขียนเองที่ดูเหมือนโฆษณา เช่น ลดราคา เฟสมักไม่อนุมัติ ส่วน “หลังการขาย” “อัปเดตแอคเคาน์” “อัปเดตอีเวนต์” เฟสอนุมัติแล้ว",
    too_long: "ความยาวข้อความถึงขีดจำกัดแล้ว",
  },
  confirm: {
    title: "ส่งเลยไหม?",
    why: "ส่งได้เฉพาะคนที่ทักมาไม่เกิน 24 ชม.",
    send_to: "ส่งถึง {n} คน",
    change: "เปลี่ยน",
    test: "ส่งทดสอบถึงฉัน",
    test_phone: "เบอร์ที่คุณเคยพิมพ์ในแชทเพจนี้",
    test_hint: "ข้อความทดสอบจะส่งเข้าแชทที่เคยพิมพ์เบอร์นี้ ถ้าไม่เคยพิมพ์ ระบบจะบอกว่าไม่พบแชท",
    test_need_phone: "ใส่เบอร์ที่คุณเคยพิมพ์ในแชทเพจนี้ก่อน",
    test_sent: "ส่งข้อความทดสอบไปที่แชทเฟสแล้ว",
    send: "ส่งเลย",
    sending: "กำลังส่ง",
    wait: "รอเฟสตรวจ",
    to_24h: "ส่งหาลูกค้าที่ทักมาใน 24 ชม.",
    approved: "เฟสอนุมัติแล้ว",
    pending: "รอเฟสตรวจ",
    none: "ไม่มีผู้รับตามที่เลือก กลับไปเปลี่ยนเพจหรือผู้รับ",
    no_recipients_toast: "ไม่มีผู้รับตามเงื่อนไขที่เลือก",
    sent_toast: "ส่งบรอดแคสต์แล้ว",
  },
  report: {
    title: "รายงาน",
    progress: "ส่งแล้ว {sent} / {total}",
    progress_label: "ความคืบหน้า",
    why_failed: "ส่งไม่ได้เพราะอะไร",
    by_page: "แยกตามเพจ",
    search: "ค้นหาชื่อเพจ",
    no_page: "ไม่พบเพจที่ค้นหา",
    show_all: "ดูทั้งหมด",
    pause: "หยุดชั่วคราว",
    resume: "ส่งต่อ",
    cancel: "ยกเลิกที่เหลือ",
    cancel_title: "ยกเลิกข้อความที่ยังไม่ส่ง {n} ข้อความ?",
    cancel_yes: "ยกเลิกเลย",
    cancel_no: "ไม่ยกเลิก",
    back: "กลับไปหน้าบรอดแคสต์",
  },
  library: {
    title: "ข้อความที่บันทึกไว้",
    back: "ย้อนกลับ",
    use: "ใช้ข้อความนี้",
    origin_std: "ข้อความมาตรฐานของระบบ",
    origin_own: "ร้านเขียนเอง",
    approved: "เฟสอนุมัติแล้ว",
    approved_n: "เฟสอนุมัติแล้ว {n} เพจ · รอตรวจ {m} เพจ",
    pending: "รอเฟสตรวจ",
  },
};

export default {
  th: { broadcast: { screens: th } },
  en: { broadcast: { screens: th } },
};

